<template>
    <div @click="checkAnimation" class="progress">
        
    </div>
</template>

<script>
    export default {
        name: 'Progress',
        methods: {
            checkAnimation() {
                document.querySelector('.progress').classList.toggle('progressFurther');
                console.log('working');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .progress {
        height: 3px;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 0%;
        opacity: 1;
        background: black;
    }

    .progressFurther {
        animation-name: progress;
        animation-duration: 1.5s;
    }

    @keyframes progress {
    0%   {  
        opacity: 1;
        width: 0%
    }

    80% {  
        width: 100%;
        opacity: 1;
    }

    100% {
        width: 100%;
        opacity: 0;
    }
    }
</style>